export default {
  'contact.title': 'Contact',
  'contact.titleHighlight': 'Me',
  'contact.subtitle': 'Feel free to reach out for collaborative research, development, or inquiries',

  // Info Section
  'contact.info.title': 'Contact Information',
  'contact.info.email': 'Email',
  'contact.info.affiliation': 'Affiliation',
  'contact.info.affiliationText': 'The University of Tokyo\nGraduate School of Interdisciplinary Information Studies\nDoctoral Program',
  'contact.info.lab': 'Laboratory',
  'contact.info.labText': 'Yatani Lab\n(Interactive Intelligent Systems Lab)',

  // Common Inquiries
  'contact.inquiries.title': 'Common Inquiries',
  'contact.inquiries.xr': 'XR technology research and development',
  'contact.inquiries.edtech': 'Educational technology and EdTech solutions',
  'contact.inquiries.gamification': 'Gamification implementation',
  'contact.inquiries.hci': 'HCI research and collaborative development',
  'contact.inquiries.consulting': 'Technical consulting',

  // Social
  'contact.social.title': 'Connect on Social Media',

  // Form
  'contact.form.name': 'Name',
  'contact.form.namePlaceholder': 'John Doe',
  'contact.form.email': 'Email Address',
  'contact.form.emailPlaceholder': 'example@company.com',
  'contact.form.organization': 'Organization',
  'contact.form.organizationPlaceholder': 'University / Company Name',
  'contact.form.subject': 'Subject',
  'contact.form.subjectPlaceholder': 'Collaborative Research Inquiry',
  'contact.form.message': 'Message',
  'contact.form.messagePlaceholder': 'Please share your inquiry (500 characters max)',
  'contact.form.charCount': '{{count}}/500 characters',
  'contact.form.required': '*',

  // Buttons
  'contact.form.submitting': 'Sending...',
  'contact.form.submit': 'Send Message',

  // Status Messages
  'contact.form.success': 'Thank you for your inquiry. We will get back to you as soon as possible.',
  'contact.form.error': 'Failed to send message. Please try again later.',
};
